import { useQuery } from '@tanstack/react-query';
import { fetchProductStatuses } from '../services/products';

export const useProductStatusesQuery = () =>
    useQuery({
        queryKey: ['smr', 'product-statuses'],
        queryFn: fetchProductStatuses,
        staleTime: 30 * 60 * 1000,
    });
